(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["astroida-november-cart"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('astroida-november-cart')) {
    customElements.define('astroida-november-cart', class extends HTMLElement {
      connectedCallback() {
        this.drawer = this.closest('#CartDrawer');
        if (!this.drawer) return;
        this.controller = new AbortController();
        this.previousFree = null;
        this.number = new Intl.NumberFormat(this.lang || 'en');
        this.refresh = () => this.renderState();
        const products = this.drawer.querySelector('[data-products]');
        if (products) {
          this.productsObserver = new MutationObserver(this.refresh);
          this.productsObserver.observe(products, {childList: true});
        }
        document.addEventListener('shopify:section:load', this.refresh, {signal: this.controller.signal});
        window.addEventListener('resize', () => this.previewOffset(), {signal: this.controller.signal});
        this.drawerObserver = new MutationObserver(() => this.previewOffset());
        this.drawerObserver.observe(this.drawer, {attributes: true, attributeFilter: ['class']});
        this.renderState();
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.productsObserver?.disconnect();
        this.drawerObserver?.disconnect();
        clearTimeout(this.celebrationTimer);
      }
      text(selector, value) {
        const node = this.drawer.querySelector(selector);
        if (node && node.textContent !== value) node.textContent = value;
      }
      message(pattern, value) {
        return (pattern || '').replaceAll('[count]', this.number.format(value));
      }
      previewOffset() {
        const bar = document.getElementById('PBarNextFrame')?.parentElement;
        const bounds = bar?.getBoundingClientRect();
        const height = document.documentElement.clientHeight;
        const overlap = bounds && bounds.height > 0 && bounds.height < 161 ? Math.max(0, height - bounds.top) : 0;
        this.drawer.style.setProperty('--ast-nov-preview-offset', Math.min(160, overlap) + 'px');
      }
      renderState() {
        const state = this.drawer.querySelector('[data-products] [data-ast-nov-state]') || this.querySelector('[data-ast-nov-state]');
        if (!state) return;
        const s = state.dataset;
        const count = Math.max(0, Number(s.eligible) || 0);
        const free = Math.max(0, Number(s.free) || 0);
        let message;
        if (count < 3) message = this.message(this.dataset.first, 3 - count);
        else if (count < 5 && free > 0) message = this.message(this.dataset.second, 5 - count);
        else if (free > 0) message = this.message(this.dataset.success, free);
        else message = this.dataset.eligible;
        this.text('[data-nov-goal]', message || '');
        this.text('[data-nov-count]', this.message(this.dataset.countLabel, count));
        this.text('[data-nov-bag-count]', this.number.format(Number(s.count) || 0));
        this.querySelectorAll('[data-nov-offer]').forEach(el => el.classList.toggle('is-reached', count >= Number(el.dataset.novOffer)));
        const track = this.querySelector('.ast-nov-track');
        track?.setAttribute('aria-valuenow', String(Math.min(5, count)));
        track?.setAttribute('aria-valuetext', this.message(this.dataset.countLabel, count));
        this.querySelectorAll('.ast-nov-track span').forEach((el, index) => el.classList.toggle('is-filled', index < count));
        this.text('[data-nov-original]', s.original || '');
        this.text('[data-nov-saved]', '− ' + (s.saved || ''));
        const savingRow = this.drawer.querySelector('[data-nov-saving-row]');
        if (savingRow) savingRow.hidden = !(Number(s.savingValue) > 0);
        const shipping = this.drawer.querySelector('[data-nov-shipping]');
        const ready = s.shippingReady === 'true';
        if (shipping) shipping.hidden = s.showShipping !== 'true';
        this.text('[data-nov-shipping-message]', ready ? this.dataset.shippingSuccess : (this.dataset.shippingProgress || '').replaceAll('[amount]', s.shippingLeft || ''));
        this.text('[data-nov-shipping-target]', ready ? '' : s.shippingThreshold || '');
        const fill = this.drawer.querySelector('[data-nov-shipping-fill]');
        const percent = Math.min(100, Math.max(0, Number(s.shippingPercent) || 0));
        if (fill) fill.style.width = percent + '%';
        this.drawer.querySelector('.ast-nov-shipping-track')?.setAttribute('aria-valuenow', String(Math.round(percent)));
        if (this.previousFree !== null && free > this.previousFree && this.dataset.animate === 'true' && !matchMedia('(prefers-reduced-motion: reduce)').matches) {
          const confetti = this.querySelector('.ast-nov-confetti');
          clearTimeout(this.celebrationTimer);
          confetti.classList.remove('is-celebrating');
          requestAnimationFrame(() => {
            if (!this.isConnected) return;
            confetti.classList.add('is-celebrating');
            this.celebrationTimer = setTimeout(() => confetti.classList.remove('is-celebrating'), 800);
          });
        }
        this.previousFree = free;
        this.previewOffset();
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
